import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import './shared/design-system/tokens.css';
import './shared/design-system/base.css';
import './shared/design-system/components.css';
import './shared/design-system/legal.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element #root not found in index.html.');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
